/* eslint-disable max-depth */
import React, { useEffect, useState } from "react";
import classnames from "classnames";
import { gettext } from "web/script/modules/django-i18n";
import BranchLink from "web/react/components/branch-link/branch-link";
import { RawBranchLink } from "web/script/utils/branch-io";
import appIcon from "./images/icon-large.png";
import styles from "./app-benefits-feed-item.css";

const sliderContent = [
    {
        // "Lyst is even better in the App"
        title: gettext("feed.in_feed_banner.title_1"),
        // "Swipe for a sneak peek"
        desc: gettext("feed.in_feed_banner.description_1"),
    },
    {
        // "Skip endless scrolling"
        title: gettext("feed.in_feed_banner.title_2"),
        // "Shop more brands and stores than anywhere else"
        desc: gettext("feed.in_feed_banner.description_2"),
    },
    {
        // "Express your style"
        title: gettext("feed.in_feed_banner.title_3"),
        // "Discover new items tailored to your style"
        desc: gettext("feed.in_feed_banner.description_3"),
    },
    {
        // "Never miss out"
        title: gettext("feed.in_feed_banner.title_4"),
        // "Sales notifications and personalised recommendations"
        desc: gettext("feed.in_feed_banner.description_4"),
    },
];

export function AppBenefitsFeedItem(): JSX.Element {
    const branchLink = RawBranchLink.InFeedBenefits;
    const [benefitCounter, setBenefitCounter] = useState<number>(0);

    useEffect(() => {
        let counter = 0;
        const carousel = setInterval(() => {
            setBenefitCounter(counter);
            if (counter === sliderContent.length - 1) {
                counter = 0;
            } else {
                counter += 1;
            }
        }, 3000);

        return (): void => {
            clearInterval(carousel);
        };
    }, []);

    function sliderItem(title, description, index): JSX.Element {
        return (
            <li className={styles.carouselSlide} key={`slider-${index}`}>
                <div
                    style={{ transform: `translateX(-${benefitCounter}00%)` }}
                    className={styles.carouselSnapper}
                >
                    <div className={styles.iconContainer}>
                        <img src={appIcon} className={styles.icon} alt="Lyst app" />
                    </div>
                    <div className={styles.textContainer}>
                        <span className={styles.benefitTitle}>{title}</span>
                        <span className={styles.benefitDescription}>{description}</span>
                    </div>
                </div>
            </li>
        );
    }
    function slideIndicatorDot(index): JSX.Element {
        const isSelected = index === benefitCounter;
        return (
            <li className={styles.carouselNavigationItem} key={index}>
                <div
                    className={classnames(styles.carouselNavigationDot, {
                        [styles.carouselNavigationDotSelected]: isSelected,
                    })}
                ></div>
            </li>
        );
    }

    const sliderItems: JSX.Element[] = [];
    const slideIndicatorDots: JSX.Element[] = [];
    for (let i = 0; i < sliderContent.length; ++i) {
        sliderItems.push(sliderItem(sliderContent[i].title, sliderContent[i].desc, i));
        slideIndicatorDots.push(slideIndicatorDot(i));
    }

    return (
        <div className={styles.carousel}>
            <BranchLink
                branchLink={branchLink}
                eventLabel={"in_feed_app_benefits"}
                title={"in_feed_app_benefits"}
            >
                <>
                    <ol className={styles.carouselList}>{sliderItems}</ol>
                    <div className={styles.carouselNavigation}>
                        <ol className={styles.carouselNavigationList}>{slideIndicatorDots}</ol>
                    </div>
                </>
            </BranchLink>
        </div>
    );
}
export default AppBenefitsFeedItem;
